module.exports = __webpack_public_path__ + "static/img/gb.10522cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gb.gif
// module id = CiP7
// module chunks = 0